module.exports = __webpack_public_path__ + "img/artist.4c1b935b.svg";